import React from 'react';
import AsyncPage from './async';
import DefaultConsumerLayout from '../../../../components/layout/DefaultConsumerLayout';

export default [
  <DefaultConsumerLayout
    key="/consumer/features/video-skin-retouch"
    exact
    path="/consumer/features/video-skin-retouch"
    component={AsyncPage}
  />,
];
